// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3bws-","validationTips":"StatementDescriptor_validationTips__2gfWo"};